<template>
  <div class="custom-control custom-checkbox custom-control-inline mr-0 p-3" v-show="showIfInactive ? row.membership_years && row.selectedSeason ? row.membership_years[row.selectedSeason].upgradeable && !!row.filtered_product_options.length : true : true">
    <input type="checkbox" ref="checkbox" @change="selectRow(row)" :checked="selected" :id="`customCheckInline${row.id}`" name="customCheckInline1" class="custom-control-input">
    <label class="custom-control-label" :for="`customCheckInline${row.id}`"></label>
  </div>
</template>

<script>
import eventBus from '@/store/EventBus.js'
// v-show on line 2 because the condition bugs out when changing year for some reason if it's a v-if, despite the condition being identical to the one in dropdown.
export default {
  props: ['row', 'options'],
  data() {
    return {
      showIfInactive: this.options ? this.options.showIfInactive : false,
      requireFinancial: this.options ? this.options.requireFinancial : false
    }
  },
  methods: {
    selectRow() {
      if (this.requireFinancial && !this.row.is_financial) {
        eventBus.$emit('financial-error', 'The horse owner is not financial. Please renew your membership before registering this horse.')
        this.$refs.checkbox.checked = false
        return
      }
      eventBus.$emit('financial-error', '')
      this.$store.commit('updateSelectedRows', this.row)
    }
  },
  computed: {
    selected() {
      return this.$store.getters.getRowState(this.row.id)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/DataTableFields/SelectRow.vue